import { type FC, useMemo } from "react";
import { useMatchMinute } from "../../../../hooks/use-match-minute";
import { usePolls } from "../../../../hooks/use-polls";
import EndedPoll from "../../../../screens/broadcast-portal/modules/polls-module/components/ended-poll/ended-poll";
import type { Post } from "../../../../types/post.types";
import PostFooter from "../../components/post-footer/post-footer";
import PostHeader from "../../components/post-header/post-header";
import { usePostBroadcastContext } from "../../post-broadcast.context";
import * as CSS from "../../posts.styles";

type PollResultPostProps = {
	post: Post;
};

const PollResultPost: FC<PollResultPostProps> = ({ post }) => {
	const { broadcastId } = usePostBroadcastContext();
	const polls = usePolls(broadcastId);
	const minute = useMatchMinute(post.date, post.minute);

	const poll = useMemo(
		() => polls.find((p) => p.id === post.pollId),
		[polls, post.pollId],
	);

	if (!poll) return null;

	return (
		<CSS.Post>
			<PostHeader time={minute} type={post.type} />

			<div style={{ marginLeft: 44 }}>
				<CSS.Title>Poll result</CSS.Title>
				<CSS.Text style={{ margin: "0.5rem 0 1rem 0" }}>"{post.text}"</CSS.Text>
				<EndedPoll poll={poll} hideSeperator />
				<PostFooter postId={post.id} postType={post.type} />
			</div>
		</CSS.Post>
	);
};

export default PollResultPost;
